import { DataProvider, ListComponent } from "../../GenericList"
import { configData } from "./businesses-config"

/**
 * Main Businesses component that displays a list of businesses
 * Uses the DataProvider and ListComponent for CRUD operations
 */
export const BusinessesComponent = () => {
  return (
    <DataProvider {...configData}>
      <ListComponent />
    </DataProvider>
  )
}